import IntelModConfigService from './intel-mod.service';
export default IntelModConfigService;